import { Accordion, Box, Button, Flex, Grid, GridItem, Heading, SimpleGrid, Text } from '@chakra-ui/react'
import React from 'react'
import { useColorModeValue } from '../../../components/ui/color-mode'
import { useTranslation } from 'react-i18next'

const ServicesCoding = () => {

    const cardColor = useColorModeValue('white', 'gray.900')
    const { t } = useTranslation();

    const OurService= [
        {
            title: t('featureChild1TitleServiceThree'),
            description: t('featureChild1DescriptionServiceThree')
        },
        {
            title: t('featureChild2TitleServiceThree'),
            description: t('featureChild2DescriptionServiceThree')
        },
        {
            title: t('featureChild3TitleServiceThree'),
            description: t('featureChild3DescriptionServiceThree')
        },
        {
            title: t('featureChild4TitleServiceThree'),
            description: t('featureChild4DescriptionServiceThree')
        }
    ]

    const textGhost = useColorModeValue('gray.600', 'gray.400')

    
  return (
    <Flex
        px={{ md: '10%', '2xl': "19%", base: 4 }}
        position={'relative'}
        py={20}
        overflow={'hidden'}
        justifyContent={'center'}
    >
        <Grid gridTemplateColumns={{md: '3fr 3fr', base: '1fr'}} gap={10} w={'full'} alignItems={'center'}>
            <GridItem>
                <Box filter={'blur(10px)'} boxSize={{md: 200, base: 120}} rounded={'full'} bgGradient={'to-tl'} gradientFrom={useColorModeValue('red.200', 'red.800')} gradientTo={useColorModeValue('blue.200', 'blue.800')} position={'absolute'} top={-20} left={{md: 20, base: 10}}/>
                <Heading maxW={{'2xl': '690px', base: '320px'}}
                fontFamily={'Onest'}
                fontSize={{ '2xl': '7xl', md: '3xl', base: '2xl' }}
                fontWeight={600}
                lineHeight={1.1}
                letterSpacing={-1.8}>{t('featureTitleServiceThree')}</Heading>

                <Text mt={6} fontSize={'md'} maxW={{'2xl': '690px', base: '320px'}}>{t('featureSubtitleServiceThree')}</Text>

                <Button fontFamily={'Momo Trust Display'} mt={8} colorPalette={''} p={{md: 6, base: 4}} size={{md: 'lg', base: 'md'}} rounded={'full'}>{t('featureCallToActionServiceThree')}</Button>
            </GridItem>
            <SimpleGrid position={'relative'} gridTemplateColumns={'1fr'} gap={4} >
                {/* {
                    OurService.map((service, index) => (
                        <Box key={index} shadow={'md'} bgColor={cardColor} p={6} rounded={20}>
                            <Box>
                                {service.icon}
                            </Box>
                            <Heading fontSize={'xl'} fontWeight={600} fontFamily={'Onest'}>{service.title}</Heading>
                            <Text mt={2} color={textGhost}>{service.description}</Text>
                        </Box>
                    ))
                } */}
                <Accordion.Root collapsible defaultValue={[t('featureChild1TitleServiceThree')]}>
                    {
                        OurService.map((item, index) => (
                            <Accordion.Item py={{md: 4, base: 3}} key={index} value={item.title}>
                                <Accordion.ItemTrigger>
                                    <Heading flex="1" fontSize={{'2xl': '2xl', base: 'lg'}} fontFamily={'Poppins'} letterSpacing={-0.8}>{item.title}</Heading>
                                    <Accordion.ItemIndicator />
                                </Accordion.ItemTrigger>
                                <Accordion.ItemContent>
                                    <Accordion.ItemBody color={textGhost}>

                                        {item.description}
                                    </Accordion.ItemBody>
                                </Accordion.ItemContent>
                            </Accordion.Item>
                            
                        ))
                    } 
                </Accordion.Root>

                
            </SimpleGrid>
        </Grid>

    </Flex>
  )
}

export default ServicesCoding